import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import Products from './components/Products';
import About from './components/About';
import CTABanner from './components/CTABanner';
import Industries from './components/Industries';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ComingSoon from './components/ComingSoon';
//import './styles/index.css';

function App() {
  return (
    <ComingSoon />
    // <div className="App">
    //   <Navbar />
    //   <main style={{ paddingTop: '72px' }}>
    //     <Hero />
    //     <StatsBar />
    //     <Products />
    //     <About />
    //     <CTABanner />
    //     <Industries />
    //     <Testimonials />
    //     <Contact />
    //   </main>
    //   <Footer />
    // </div>
  );
}

// function App() {
//   return (
//     <div className="App">
//       <Navbar />
//       <main style={{ paddingTop: '72px' }}>
//         <Hero />
//         <StatsBar />
//         <Products />
//         <About />
//         <CTABanner />
//         <Industries />
//         <Testimonials />
//         <Contact />
//       </main>
//       <Footer />
//     </div>
//   );
// }

export default App;
